module.exports = "<div *ngIf=\"!!lastPaymentDate\" class=\"row text-center body-copy\">\r\n    {{lastPaymentText}} {{lastPaymentDate}}\r\n</div>";